module.exports = __webpack_public_path__ + "static/img/IMG_6371.925a4be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-uvegora/IMG_6371.jpg
// module id = 610
// module chunks = 0